import React from 'react';
import { LongArrowRight } from './LongArrowRight';

export const LongArrowLeft: React.FC<React.HTMLAttributes<SVGElement>> = (
  props
) => <LongArrowRight style={{ transform: 'scale(-1)' }} {...props} />;
